import axios from "axios";

async function fetchData(URL, extra = {}) {
  try {
    const response = await axios.get(URL, extra);
    return {
      success: true,
      data: response.data,
    };
  } catch (error) {
    return { success: false };
  }
}

export default fetchData;
